export const FOCUS_SINGLE_SECURITY_QUICKFLOW_EVENT_NAME = 'focusSingleSecurityQuickflowInput';
export const FOCUS_MULTI_SECURITY_QUICKFLOW_EVENT_NAME = 'focusMultiSecurityQuickflowInput';
export const QUICKFLOWS_SINGLE_SECURITY_COOKIE_NAME = 'quickflowsSingleSecurityCookieV2';
export const QUICKFLOWS_MENU_ON_SINGLE_SECURITY_TAB_COOKIE_NAME = 'quickflowsMenuOnSingleSecurityTabCookieName';
